import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { SharedState } from '../models/shared.models';
import * as selectors from '../selectors/shared.selectors';

@Injectable()
export class SharedFacadeService extends FacadeService {
  activeTab: 'summary' | 'details' = 'summary';
  customerActiveTab: 'summary' | 'details' = 'summary';

  constructor(public override store: Store<SharedState>) {
    super(store);
  }

  // OBSERVABLES
  viewMemberSummary$ = this.storeSelect(selectors.getViewMemberSummary);
  viewMemberSearch$ = this.storeSelect(selectors.getViewMemberSearch);
  viewCustomerSummary$ = this.storeSelect(selectors.getViewCustomerSummary);
  customerActiveTab$ = this.storeSelect(selectors.getCustomerActiveTab);
  selectedSearchTabIndex$ = this.storeSelect(selectors.getSelectedSearchTabIndex);
}
